import { combineReducers } from "redux";
import { IntlReducer as Intl } from "react-redux-multilingual";

import { userReducer } from "./user";
import { companyReducer } from "./company";
import { migrationReducer } from "./migration";
import { activityReducer } from "./activity";

import { RESET_STATE } from "../constants/action_types";
import { coworkerReducer } from "./coworker";
import { connectReducer } from "./connect";
import apps from "./apps";
import { act } from "react-dom/test-utils";

function modifyNestedObject(obj, keysString, newValue) {
  const keys = keysString.split(".");
  let currentObj = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (
      !currentObj.hasOwnProperty(key) ||
      typeof currentObj[key] !== "object"
    ) {
      currentObj[key] = {};
    }
    currentObj = currentObj[key];
  }

  const finalKey = keys[keys.length - 1];
  currentObj[finalKey] = newValue;
  return obj;
}
const loaderReducer = (state, action) => {
  if (action.type.includes("LOADER") || action.type.includes("INIT"))
    return action.payload || false;
  if (action.type.includes("REQ") && !action?.payload?.no_loader) return true;
  if (action.type.includes("RESPONSE") && !action?.payload?.no_loader) return false;
  return !!state;
};
const appReducer = combineReducers({
  user: userReducer,
  company: companyReducer,
  migration:migrationReducer,
  coworker: coworkerReducer,
  activity: activityReducer,
  connect: connectReducer,
  apps,
  showLoader: loaderReducer,
  Intl,
});

const rootReducer = (state, action) => {
  switch (action.type) {
    case RESET_STATE:
      modifyNestedObject(state, action.key, action.value);
      return appReducer(state, action);
    default:
      return appReducer(state, action);
  }
};

export default rootReducer;
